import SEO from "../components/common/SEO"
import Hero from "../components/home/Hero"
import CategoriesPreview from "../components/home/CategoriesPreview"
import FeaturedProducts from "../components/home/FeaturedProducts"
import WhyChooseUs from "../components/home/WhyChooseUs"
import CTASection from "../components/home/CTASection"
export default function Home() {
  return (
    <>
      <SEO
        title="Accueil"
        description="Grossiste en fournitures textiles, mercerie, tissus, fermetures, fils, élastiques, velcro, boutons et accessoires pour professionnels."
        keywords="grossiste textile, mercerie, tissus, fermetures éclair, fils à coudre, velcro, accessoires textile, Tunisie"
        url="https://www.khenissitextiles.com"
      />

      <Hero />

      <CategoriesPreview />

    <FeaturedProducts /> 
    <WhyChooseUs />
    <CTASection />
    </>
  )
}